export function getColumn(data, columnName) {
  return data.map(function (item) {
    return item[columnName] * 1;
  });
}
export function isRasterFileData(data) {
  if (data === undefined) {
    return false;
  }

  if (!Array.isArray(data) && data.data !== undefined) {
    return true;
  } else {
    return false;
  }
}
export function isRasterFileDataArray(data) {
  if (Array.isArray(data)) {
    if (data.length === 0) {
      return false;
    }

    if (isRasterFileData(data[0])) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}
export function isNumberArray(data) {
  if (Array.isArray(data)) {
    if (data.length === 0) {
      return true;
    }

    if (typeof data[0] === 'number') {
      return true;
    } else {
      return false;
    }
  }

  return false;
}